import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import DiagnosisManager from './DiagnosisManager';
import PrescriptionTab from './PrescriptionTab';
import TestsForm from './TestsForm';
import ReferralsForm from './ReferralsForm';
import SymptomsForm from './SymptomsForm';

const ConsultationTabs = ({
  tabValue,
  handleChange,
  consultationData,
  setConsultationData,
  openPrescriptionModal,
}) => {
  return (
    <Box>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label='consultation tabs'
      >
        <Tab label='Symptoms' />
        <Tab label='Diagnosis' />
        <Tab label='Prescriptions' />
        <Tab label='Tests' />
        <Tab label='Referrals' />
        <Tab label='Follow‑Up & Notes' />
      </Tabs>

      <Box sx={{ marginTop: 2 }}>
        {tabValue === 0 && (
          <SymptomsForm
            symptoms={consultationData.symptoms}
            setSymptoms={symptoms =>
              setConsultationData(prev => ({ ...prev, symptoms }))
            }
          />
        )}
        {tabValue === 1 && (
          <DiagnosisManager
            diagnoses={consultationData.diagnoses || []}
            setDiagnoses={(diagnoses) =>
              setConsultationData((prev) => ({ ...prev, diagnoses }))
            }
          />
        )}
        {tabValue === 2 && (
          <PrescriptionTab
            prescriptions={consultationData.prescription?.medications || []}
            setPrescriptions={(medications) =>
              setConsultationData((prev) => ({
                ...prev,
                prescription: { medications },
              }))
            }
            openPrescriptionModal={openPrescriptionModal}
          />
        )}
        {tabValue === 3 && (
          <TestsForm
            testsOrdered={consultationData.testsOrdered || []}
            setTestsOrdered={(testsOrdered) =>
              setConsultationData((prev) => ({ ...prev, testsOrdered }))
            }
          />
        )}
        {tabValue === 4 && (
          <ReferralsForm
            referrals={consultationData.referrals || []}
            setReferrals={(referrals) =>
              setConsultationData((prev) => ({ ...prev, referrals }))
            }
          />
        )}
        {tabValue === 5 && (
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={consultationData.follow_up_required || false}
                  onChange={(e) =>
                    setConsultationData((prev) => ({
                      ...prev,
                      follow_up_required: e.target.checked,
                    }))
                  }
                />
              }
              label='Follow‑Up Required'
            />
            <TextField
              fullWidth
              type='date'
              label='Follow‑Up Date'
              InputLabelProps={{ shrink: true }}
              value={
                consultationData.follow_up_date
                  ? consultationData.follow_up_date.substring(0, 10)
                  : ''
              }
              onChange={(e) =>
                setConsultationData((prev) => ({
                  ...prev,
                  follow_up_date: e.target.value,
                }))
              }
              sx={{ marginTop: 2 }}
            />
            <TextField
              fullWidth
              label='Additional Notes'
              multiline
              rows={4}
              value={consultationData.notes || ''}
              onChange={(e) =>
                setConsultationData((prev) => ({
                  ...prev,
                  notes: e.target.value,
                }))
              }
              sx={{ marginTop: 2 }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ConsultationTabs;
